import PropTypes from 'prop-types';

export const PickupContactPropType = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phoneNumber: PropTypes.string,
  phoneNumberExtension: PropTypes.string,
  emailAddress: PropTypes.string,
  locationNotes: PropTypes.string,
});

/**
 * @typedef {object} PickupContactPropType
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} phoneNumber
 * @property {string} phoneNumberExtension
 * @property {string} emailAddress
 * @property {string} locationNotes
 */
